var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mailData)?_c('iframe',{ref:"iframe",staticClass:"template-frame",attrs:{"title":"static mail template","srcdoc":_vm.mailData,"width":"100%"},on:{"load":_vm.getHeight}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }